import Component from "vue-class-component";
import { EventBus } from "../Controls/EventBus";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { ParametresInstance } from "../Controls/Parameters";
import { DsnHeaderDto } from "../../dto/GenApi.iNotPaie.Dto/DsnHeaderDto";
import { DsnTypeDeclaration } from "../../dto/GenApi.iNotPaie.Dto/DsnTypeDeclaration";
import { DsnTypeEnvoi } from "../../dto/GenApi.iNotPaie.Dto/DsnTypeEnvoi";
import { DsnModeEnvoi } from "../../dto/GenApi.iNotPaie.Dto/DsnModeEnvoi";
import { DsnNatureDeclaration } from "../../dto/GenApi.iNotPaie.Dto/DsnNatureDeclaration";
import { SocieteDto } from "../../dto/GenApi.iNotPaie.Dto/SocieteDto";
import { ModalAlerteOptions } from "../modalComponents/modalAlerte/modalAlerte";
import ModalVisualisationDetailsDsnComponent from "./modalVisualisationDetailsDsn/modalVisualisationDetailsDsn";
import ModalCompteRenduDsnComponent from "./modalCompteRenduDsn/modalCompteRenduDsn";
import ModalEditionDsnComponent from "./modalEditionDsn/modalEditionDsn";
import * as $ from "jquery";
import EventConstants from "../Controls/EventConstants";
import { DeclarationOethDto } from "../../dto/GenApi.iNotPaie.Dto/DeclarationOethDto";
import { ExerciceDto } from "../../dto/GenApi.iNotPaie.Dto/ExerciceDto";
import { Vue } from "vue-property-decorator";
import { NotificationServiceInstance } from "../../shared/services/notification.service";
import { ColorServiceInstance } from "../../shared/services/color.service";
import ModalAjoutContratAmorcageTauxPAS from "./tableAmorcageTauxPAS/modalAjoutContratAmorcageTauxPAS/modalAjoutContratAmorcageTauxPAS";

interface DsnOngletParameters {
	Liste: DsnHeaderDto[];
	Years: number[];
	Year?: number;
	Salaries: string[];
	Salarie: string;
	Motifs: string[];
	Motif: string;
}

interface DsnLine {
	dns: DsnHeaderDto;
	loading: boolean
}

@Component({
	filters: {
		capitalize(value: string) {
			if (!value) {
				return "";
			}
			value = value.toString();

			return value.charAt(0).toUpperCase() + value.slice(1);
		}
	},
	components: {
		ModalVisualisationDetailsDsnComponent: require("./modalVisualisationDetailsDsn/modalVisualisationDetailsDsn.vue.html"),
		ModalCompteRenduDsnComponent: require("./modalCompteRenduDsn/modalCompteRenduDsn.vue.html"),
		ModalEditionDsnComponent: require("./modalEditionDsn/modalEditionDsn.vue.html"),
		Loader: require("./../../shared/components/Loader/Loader.vue.html"),
		TableOeth: require("./tableOeth/tableOeth.vue.html"),
		TableAmorcageTauxPAS: require("./tableAmorcageTauxPAS/tableAmorcageTauxPAS.vue.html"),
		ModalAjoutContratAmorcageTauxPAS: require("./tableAmorcageTauxPAS/modalAjoutContratAmorcageTauxPAS/modalAjoutContratAmorcageTauxPAS.vue.html")
	},
	beforeRouteUpdate(to, from, next) {
		next(v => {
			(v as DsnComponent).initialize();
		});
	},
	beforeRouteEnter(to, from, next) {
		next(v => {
			(v as DsnComponent).initialize();
		});
	}
})
export default class DsnComponent extends Vue {
	public siret?: number;
	public undefinedChoice = "*";
	public tab = 0;
	public tabParameters: DsnOngletParameters[] = [];
	public title = "";
	public filteredList: DsnLine[] = [];
	public filteredListOeth: DeclarationOethDto[] = [];
	public isLoading = 0;
	public dataReady = false;
	public currentAction = false;
	public nature: DsnNatureDeclaration = DsnNatureDeclaration.MENSUELLE;
	public modalVisualisationDetailsDsnComponent?: ModalVisualisationDetailsDsnComponent = undefined;
	public modalCompteRenduDsnComponent?: ModalCompteRenduDsnComponent = undefined;
	public modalEditionDsnComponent?: ModalEditionDsnComponent = undefined;
	public modalAjoutContratAmorcageTauxPAS?: ModalAjoutContratAmorcageTauxPAS = undefined;
	private colorService = ColorServiceInstance;

	public listAmorcageYears: number[] = [];
	public selectedAmorcageYear: number | undefined = undefined;

	public currentOrderColumn = "NumeroOrdre";
	public orderingDesc = true;

	private lastExerciceClosed!: ExerciceDto;

	public mounted(): void {
		const societe = ParametresInstance.societeCourante;
		if (societe != undefined && societe.PeriodeActive != undefined) {
			this.refreshParameters();
			this.siret = societe.Siret;
		}
		EventBus.$on(EventConstants.SOCIETE_CHANGED, (e) => {
			const societe = e as SocieteDto;
			if (societe != undefined && societe.PeriodeActive != undefined) {
				this.refreshParameters();
				this.siret = societe.Siret;
			}
		});
	}

	public initialize(): void {
		this.tabParameters = [];
		this.changeTab(this.tab);
		this.getLastExerciceClosed();
	}

	private getLastExerciceClosed(): void {
		ServicesFactoryInstance.ExercicesService.getDernierExerciceCloture(data => {
			this.lastExerciceClosed = data;
		});
	}

	public changeTab(index: number): void {
		if (this.currentAction) {
			return;
		}

		this.dataReady = false;
		this.tab = index;
		switch (this.tab) {
		case 0:
			this.title = "Génération mensuelle";
			this.nature = DsnNatureDeclaration.MENSUELLE;
			break;
		case 1:
			this.title = "Déclaration d'arrêt de travail";
			this.nature = DsnNatureDeclaration.ARRET;
			break;
		case 2:
			this.title = "Reprise suite à arrêt de travail";
			this.nature = DsnNatureDeclaration.REPRISE;
			break;
		case 3:
			this.title = "Fin de contrat de travail";
			this.nature = DsnNatureDeclaration.FINCONTRATUNIQUE;
				break;
			case 4:
				this.title = "Amorçage (taux PAS)";
				this.nature = DsnNatureDeclaration.AMORCAGETAUXPAS;
				this.dataReady = true;
				break;
		case 5:
			this.title = "Déclaration OETH";
			this.nature = DsnNatureDeclaration.OETH;
			this.dataReady = true;
			break;
		default:
		}

		if (this.tabParameters[this.tab] == undefined || this.nature == DsnNatureDeclaration.OETH) {
			this.refreshParameters();
		} else {
			this.filterList();
		}
	}

	public refreshParameters(): void {
		this.tabParameters[this.tab] = {
			Motif: this.undefinedChoice,
			Salarie: this.undefinedChoice,
			Year: undefined,
			Years: [],
			Liste: [],
			Motifs: [],
			Salaries: []
		};
		this.isLoading++;

		if (this.nature == DsnNatureDeclaration.OETH) {
			this.refreshOETH();
		} else {
			ServicesFactoryInstance.DsnService.getFilterParameters(this.nature, data => {
				this.tabParameters[this.tab].Years = data.Annees.sort((a, b) => b - a);
				if (this.tabParameters[this.tab].Years.length > 0) {
					this.tabParameters[this.tab].Year = this.tabParameters[this.tab].Years[0];
				}
				this.refreshList();
				this.isLoading--;
			}, () => this.isLoading--);
		}
	}

	public refreshOETH(): void {
		ServicesFactoryInstance.DeclarationOethService.GetListeDeclarationsOeth(true, data => {
			this.filteredListOeth = data;
			this.$forceUpdate();
		});
	}

	// Trigger l'évenement pour ajouter un contrat au tableau de l'armoçage du taux PAS
	public onAddSalarie(idContrat: number): void {
		ServicesFactoryInstance.AmorcageTauxPASService.SaveAmorcageTauxPASByContrat(idContrat, () => {
			EventBus.$emit(EventConstants.DSN_REFRESH_MODULE_AMORCAGE_TAUX_PAS);
		});
	}

	public onListYearsChange(years: number[]): void {
		this.listAmorcageYears = years.sort((a, b) => b - a);
	}

	public onSelectedYearChange(year: number): void {
		this.selectedAmorcageYear = year;
	}

	public emitSelectedYearChange(): void {
		EventBus.$emit(EventConstants.DSN_SELECTED_YEAR_CHANGE_AMORCAGE_TAUX_PAS, this.selectedAmorcageYear);
	}

	public getTitleEmpty(): string {
		switch (this.tab) {
		case 0:
			return "Aucune génération mensuelle";
		case 1:
			return "Aucun arrêt de travail";
		case 2:
			return "Aucune reprise/suite d'arrêt de travail";
		case 3:
				return "Aucune fin de contrat de travail";
			case 4:
				return "Aucun amorçage (taux PAS)";
		case 5:
			return "Aucune déclaration OETH";
		default:
			return "Erreur titre";
		}
	}

	public refreshList(): void {
		if (this.tabParameters[this.tab].Year == undefined) {
			this.tabParameters[this.tab].Liste = [];
			this.filterList();
		} else {
			this.isLoading++;
			const tabGet = this.tab;
			ServicesFactoryInstance.DsnService.getListeDsnMetadata(this.nature, (this.tabParameters[tabGet].Year as number), data => {
				this.tabParameters[tabGet].Liste = data;

				const uniqueSalarie = data
					.filter(x => x.NomSalarie != undefined && x.PrenomSalarie != undefined)
					.map(x => (x.NomSalarie + " " + x.PrenomSalarie) as string)
					.filter(function(item, i, ar) {
						return ar.indexOf(item) === i;
					});

				const uniqueMotif = data
					.filter(x => x.Motif != undefined)
					.map(x => x.Motif as string)
					.filter(function(item, i, ar) {
						return ar.indexOf(item) === i;
					});

				this.tabParameters[tabGet].Salaries = uniqueSalarie;
				this.tabParameters[tabGet].Motifs = uniqueMotif;
				this.filterList();
				this.isLoading--;
			}, () => this.isLoading--);
		}
	}

	public filterList(): void {
		this.filteredList = [];
		const getList = this.tabParameters[this.tab].Liste.filter(x => x != undefined).sort((a, b) => a.Mois < b.Mois ? 1 : -1);

		for (let i = 0; i < getList.length; i++) {
			this.filteredList.push({
				loading: false,
				dns: getList[i]
			});
		}
		this.dataReady = true;
		this.currentAction = false;
	}

	public visualiser(item: DsnLine): void {
		this.modalVisualisationDetailsDsnComponent = this.$refs.modalVisualisationDetailsDsnComponent as ModalVisualisationDetailsDsnComponent;

		this.modalVisualisationDetailsDsnComponent.Init(item.dns.IdDsnMetadata);
		$("#modalVisualisationDetailsDsnComponent").modal("show");
	}

	public demandeDepotDsn(item: DsnLine, estManu: boolean): void {
		const dsn = item.dns;

		if (dsn.EtatConformite == "OK") {
			const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
				message: "Voulez-vous envoyer une dsn - Annule et remplace ?",
				callBackYes: () => {
					this.demandeDepotDsnOeth(item, estManu);
				}
			});
			EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
		} else {
			this.demandeDepotDsnOeth(item, estManu);
		}
	}

	private demandeDepotDsnOeth(item: DsnLine, estManu: boolean): void {
		const dsn = item.dns;

		if (dsn.ExisteOethAIntegrer) {
			const modalOptionsOeth: ModalAlerteOptions = new ModalAlerteOptions({
				message: "Une déclaration OETH est prête, voulez-vous l'intégrer à votre DSN ?",
				callBackYes: () => {
					this.depotDsn(item, estManu, true);
				},
				callBackNo: () => {
					this.depotDsn(item, estManu, false);
				}
			});
			EventBus.$emit(EventConstants.MODAL_ALERT, modalOptionsOeth);
		} else {
			this.depotDsn(item, estManu, false);
		}
	}

	public depotDsn(item: DsnLine, estManu: boolean, integreOeth: boolean): void {
		if (estManu) {
			this.ouverturePopupEditionDsn(item.dns.IdDsnMetadata, integreOeth, item.dns.NatureDeclaration);
		} else {
			this.faireDepot(item, integreOeth);
		}
	}

	public ouverturePopupEditionDsn(idDsnMetadata: number, integreOeth: boolean, nature: DsnNatureDeclaration): void {
		this.modalEditionDsnComponent = this.$refs.modalEditionDsnComponent as ModalEditionDsnComponent;
		this.modalEditionDsnComponent.Init(idDsnMetadata, integreOeth, nature);
		$("#modalEditionDsnComponent").modal("show");
	}

	public ouverturePopupEditionDsnAmorcage(idDsnAmorcage: number): void {
		const idDsn = idDsnAmorcage;

		this.modalEditionDsnComponent = this.$refs.modalEditionDsnComponent as ModalEditionDsnComponent;
		this.modalEditionDsnComponent.Init(idDsn, false, DsnNatureDeclaration.AMORCAGETAUXPAS);
		$("#modalEditionDsnComponent").modal("show");
	}

	public faireDepot(item: DsnLine, integreOeth: boolean): void {
		const idDsnMetadata = item.dns.IdDsnMetadata;
		item.loading = true;
		this.currentAction = true;

		this.isLoading++;

		ServicesFactoryInstance.DsnService.envoyerDepot(idDsnMetadata, integreOeth, () => {
			this.isLoading--;
			this.refreshList();

			item.loading = false;
			this.currentAction = false;
		}, () => {
			this.isLoading--;
			item.loading = false;
			this.currentAction = false;
		});
	}

	public compterendu(item: DsnLine): void {
		const dsn = item.dns;
		this.isLoading++;
		const idDsnMetadata = dsn.IdDsnMetadata;

		ServicesFactoryInstance.DsnService.rafraichir(idDsnMetadata, data => {
			this.isLoading--;
			if (data.Erreurs != undefined && data.Erreurs.length > 0) {
				for (const erreur of data.Erreurs) {
					NotificationServiceInstance.SendFailed(erreur);
				}
			} else {
				this.modalCompteRenduDsnComponent = this.$refs.modalCompteRenduDsnComponent as ModalCompteRenduDsnComponent;

				this.modalCompteRenduDsnComponent.Init(idDsnMetadata);
				$("#modalCompteRenduDsnComponent").modal("show");
			}
			this.refreshList();
		}, () => this.isLoading--);
	}

	// Affiche la modal permettant de sélectionner un contrat à ajouter au tableau du taux PAS
	public showModalAjoutTauxPAS(): void {
		if (this.modalAjoutContratAmorcageTauxPAS == undefined) {
			this.modalAjoutContratAmorcageTauxPAS = this.$refs.modalAjoutContratAmorcageTauxPAS as ModalAjoutContratAmorcageTauxPAS;
		}

		this.modalAjoutContratAmorcageTauxPAS.init();
		$("#modalAjoutContratAmorcageTauxPAS").modal("show");
	}

	public getTypeDeclarationLibelle(type: DsnTypeDeclaration): string {
		switch (type) {
		case DsnTypeDeclaration.Normale:
			return "Normal";
		case DsnTypeDeclaration.NormaleNeant:
			return "Normal néant";
		case DsnTypeDeclaration.Annule:
			return "Annule";
		case DsnTypeDeclaration.AnnuleEtRemplaceIntegral:
			return "Annule et remplace intégral";
		case DsnTypeDeclaration.AnnuleEtRemplaceNeant:
			return "Annule et remplace néant";
		default:
			return "";
		}
	}

	public getTypeEnvoiLibelle(type: DsnTypeEnvoi): string {
		switch (type) {
		case DsnTypeEnvoi.EnvoiNeant:
			return "Néant";
		case DsnTypeEnvoi.EnvoiNormal:
			return "Normal";
		default:
			return "";
		}
	}

	public getModeEnvoiLibelle(type: DsnModeEnvoi): string {
		switch (type) {
		case DsnModeEnvoi.EnvoiFichierTest:
			return "Test";
		case DsnModeEnvoi.EnvoiFichierReel:
			return "Réel";
		default:
			return "";
		}
	}

	public getClassOfOrder(columnName: string, desc: any): string {
		if (columnName == this.currentOrderColumn && this.orderingDesc == desc) {
			return "active";
		}

		return "icons";
	}

	public orderBy(columnName: string): void {
		if (this.currentOrderColumn == columnName) {
			this.orderingDesc = !this.orderingDesc;
		} else {
			this.orderingDesc = true;
		}
		this.currentOrderColumn = columnName;
		this.doOrder();
	}

	private doOrder(): void {
		const orderingDesc = this.orderingDesc;
		const columnName = this.currentOrderColumn;

		if (this.filteredList != undefined) {
			this.filteredList = this.filteredList.sort(function(a, b) {
				if (a.dns[columnName] < b.dns[columnName]) {
					return (orderingDesc ? -1 : 1);
				}
				if (a.dns[columnName] > b.dns[columnName]) {
					return (orderingDesc ? 1 : -1);
				}

				return 0;
			});
		}
	}

	public fermetureEdition(dsnNature?: DsnNatureDeclaration) {
		if (dsnNature == DsnNatureDeclaration.AMORCAGETAUXPAS) {
			NotificationServiceInstance.SendSuccess("L'envoi de la DSN a bien été effectuée.");
			EventBus.$emit(EventConstants.DSN_REFRESH_CURRENT_LIST_AMORCAGE_TAUX_PAS);
		} else {
			this.refreshList();
		}
	}

	public isButtonDisabled(item: DsnLine): boolean {
		if ((item.dns.NatureDeclaration == DsnNatureDeclaration.MENSUELLE || item.dns.NatureDeclaration == DsnNatureDeclaration.FINCONTRATUNIQUE) && item.dns.EtatEnvoi == "OK" && item.dns.EtatConformite == null) {
			return true;
		}

		return false;
	}

	public openSalarie(idSalarie: number, fullName: string): void {
		EventBus.NavigateTo({ path: "/ficheSalarie/" + idSalarie, query: { titre: fullName } });
	}
}



// WEBPACK FOOTER //
// ./src/components/dsn/dsn.ts